<!-- ── NON-EMBEDDED: full fixed chat window ─────────────────────────────── -->
@if (!embedded && showChatBox) {
  <div class="chat-box">
    <div class="chat-header">
      <div class="avatar-stack">
        <div class="av" style="background:#dbeafe;color:#1e40af;z-index:4">SR</div>
        <div class="av" style="background:#dcfce7;color:#166534;z-index:3">JK</div>
        <div class="av" style="background:#fef3c7;color:#92400e;z-index:2">AM</div>
      </div>
      <div class="header-info">
        <div class="hdr-title">{{ "sale4you.team.chat" | translate }}</div>
        <div class="hdr-sub">
          <span class="online-dot"></span>
          {{ "real.time.collaboration" | translate }}
        </div>
      </div>
      <div class="header-actions">
        <button aria-label="חיפוש" class="icon-btn"><mat-icon>search</mat-icon></button>
        <button aria-label="סגירה" class="icon-btn" (click)="closeChatBox()"><mat-icon>close</mat-icon></button>
      </div>
    </div>
    <div #messageContainer class="messages" (scroll)="onScroll($event)">
      <div class="time-divider">Today</div>
      @for (group of messageGroups; track group; let gi = $index) {
        @if (group.showUnreadDivider) {
          <div class="unread-divider">
            {{ group.unreadCount }} {{ 'new.messages' | translate }}
          </div>
        }
        <div class="msg-group" [ngClass]="{'spaced': gi < messageGroups.length - 1}">
          @if (!isMe(group.sender) && group.messages.length > 1) {
            <div class="sender-name">
              {{ group.senderName }}
            </div>
          }
          @for (msg of group.messages; track msg; let first = $first; let last = $last) {
            <div class="msg-row" [ngClass]="isMe(msg.user.email) ? 'mine' : 'them'" [class.msg-enter]="msg.isNew">
              <div class="av-slot">
                @if (!isMe(msg.user.email) && last) {
                  <div class="av"
                    [style.background]="getUserBg(msg.user.id)" [style.color]="getUserFg(msg.user.id)">
                    {{ getInitials(msg.user.username) }}
                  </div>
                }
              </div>
              <div class="bub-col">
                @if (!isMe(msg.user.email) && group.messages.length === 1) {
                  <div class="sender-name" style="padding-left:0"
                    >
                    {{ msg.user.username }}
                  </div>
                }
                <div class="bubble" [ngClass]="[getBubbleRadius(isMe(msg.user.email), first, last, group.messages.length)]">
                  @if (msg.replyTo) {
                    <div class="reply-quote">
                      <span class="rq-name">{{ msg.replyTo.name }}</span>
                      {{ msg.replyTo.text | slice:0:80 }}{{ msg.replyTo.text?.length > 80 ? '…' : '' }}
                    </div>
                  }
                  {{ msg.message }}
                </div>
                @if (msg.reactions?.length > 0) {
                  <div class="reactions">
                    @for (rxn of msg.reactions; track rxn) {
                      <div class="rxn-pill"
                        [class.rxn-pill--active]="rxn.reacted"
                        (click)="toggleReaction(msg, rxn.emoji)">
                        <span class="em">{{ rxn.emoji }}</span>
                        <span class="cnt">{{ rxn.count }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="side-actions">
                <span class="ts-label">{{ msg.timestamp }}</span>
                <div class="rxn-picker">
                  @for (emoji of REACTIONS; track emoji) {
                    <button class="ha-btn rxn-pick-btn"
                    (click)="addReaction(msg, emoji)">{{ emoji }}</button>
                  }
                </div>
                <button aria-label="השב להודעה" class="ha-btn" (click)="setReply(msg)"><mat-icon>reply</mat-icon></button>
              </div>
            </div>
          }
          @if (isMe(group.sender) && group.readBy?.length > 0) {
            <div class="read-receipts">
              @for (reader of group.readBy; track reader) {
                <div class="read-av"
                  [style.background]="getUserBg(reader.id)" [style.color]="getUserFg(reader.id)"
                  [title]="reader.username + ' read this'">
                  {{ getInitials(reader.username) }}
                </div>
              }
            </div>
          }
        </div>
      }
      @if (typingUsers.size > 0) {
        <div class="typing-row">
          <div class="av-slot">
            <div class="av" style="background:#dbeafe;color:#1e40af">
              {{ getInitials(typingUsers.values().next().value) }}
            </div>
          </div>
          <div class="typing-bubble">
            <span class="td"></span><span class="td"></span><span class="td"></span>
          </div>
        </div>
      }
    </div>
    <button aria-label="גלילה להודעה האחרונה" class="scroll-bottom-btn" [class.visible]="!isAtBottom" (click)="scrollToBottom()">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
    @if (replyTarget) {
      <div class="reply-bar">
        <div class="preview">
          <div class="rep-name">{{ replyTarget.senderName }}</div>
          <div class="rep-text">{{ replyTarget.text }}</div>
        </div>
        <button aria-label="סגירה" class="close-rep" (click)="clearReply()"><mat-icon>close</mat-icon></button>
      </div>
    }
    <div class="input-area">
      <div class="input-wrap">
        <input type="text" [(ngModel)]="newMessage" (keydown)="onKeypress()"
          (keyup.enter)="sendMessage()" placeholder="Message the team…" aria-label="Type a message"/>
        <button aria-label="הוספת אימוג׳י" class="input-icon"><mat-icon>mood</mat-icon></button>
        <button aria-label="צירוף קובץ" class="input-icon"><mat-icon>attach_file</mat-icon></button>
      </div>
      <button aria-label="שליחה" class="send-btn" [class.disabled]="!newMessage.trim()" (click)="sendMessage()">
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
}

<!-- ── EMBEDDED: inside Adaline panel ──────────────────────────────────── -->
@if (embedded) {
  <div class="embedded-subheader">
    <span class="online-dot"></span>
    <span>צ'אט עם נציג</span>
    @if (currentRoomId) {
      <button class="delete-chat-btn" (click)="deleteCurrentChat()" title="מחק שיחה">
        <mat-icon>delete_outline</mat-icon>
      </button>
    }
  </div>
  <div #messageContainer class="messages" (scroll)="onScroll($event)">
    <div class="time-divider">Today</div>
    @for (group of messageGroups; track group; let gi = $index) {
      <div class="msg-group" [ngClass]="{'spaced': gi < messageGroups.length - 1}">
        @if (!isMe(group.sender) && group.messages.length > 1) {
          <div class="sender-name">
            {{ group.senderName }}
          </div>
        }
        @for (msg of group.messages; track msg; let first = $first; let last = $last) {
          <div class="msg-row" [ngClass]="isMe(msg.user.email) ? 'mine' : 'them'" [class.msg-enter]="msg.isNew">
            <div class="av-slot">
              @if (!isMe(msg.user.email) && last) {
                <div class="av"
                  [style.background]="getUserBg(msg.user.id)" [style.color]="getUserFg(msg.user.id)">
                  {{ getInitials(msg.user.username) }}
                </div>
              }
            </div>
            <div class="bub-col">
              @if (!isMe(msg.user.email) && group.messages.length === 1) {
                <div class="sender-name" style="padding-left:0"
                  >
                  {{ msg.user.username }}
                </div>
              }
              <div class="bubble" [ngClass]="[getBubbleRadius(isMe(msg.user.email), first, last, group.messages.length)]">
                @if (msg.replyTo) {
                  <div class="reply-quote">
                    <span class="rq-name">{{ msg.replyTo.name }}</span>
                    {{ msg.replyTo.text | slice:0:80 }}{{ msg.replyTo.text?.length > 80 ? '…' : '' }}
                  </div>
                }
                {{ msg.message }}
              </div>
              @if (msg.reactions?.length > 0) {
                <div class="reactions">
                  @for (rxn of msg.reactions; track rxn) {
                    <div class="rxn-pill"
                      [class.rxn-pill--active]="rxn.reacted"
                      (click)="toggleReaction(msg, rxn.emoji)">
                      <span class="em">{{ rxn.emoji }}</span>
                      <span class="cnt">{{ rxn.count }}</span>
                    </div>
                  }
                </div>
              }
            </div>
            <div class="side-actions">
              <span class="ts-label">{{ msg.timestamp }}</span>
              <div class="rxn-picker">
                @for (emoji of REACTIONS; track emoji) {
                  <button class="ha-btn rxn-pick-btn"
                  (click)="addReaction(msg, emoji)">{{ emoji }}</button>
                }
              </div>
              <button aria-label="השב להודעה" class="ha-btn" (click)="setReply(msg)"><mat-icon>reply</mat-icon></button>
            </div>
          </div>
        }
        @if (isMe(group.sender) && group.readBy?.length > 0) {
          <div class="read-receipts">
            @for (reader of group.readBy; track reader) {
              <div class="read-av"
                [style.background]="getUserBg(reader.id)" [style.color]="getUserFg(reader.id)"
                [title]="reader.username + ' read this'">
                {{ getInitials(reader.username) }}
              </div>
            }
          </div>
        }
      </div>
    }
    @if (typingUsers.size > 0) {
      <div class="typing-row">
        <div class="av-slot">
          <div class="av" style="background:#dbeafe;color:#1e40af">
            {{ getInitials(typingUsers.values().next().value) }}
          </div>
        </div>
        <div class="typing-bubble">
          <span class="td"></span><span class="td"></span><span class="td"></span>
        </div>
      </div>
    }
  </div>
  @if (replyTarget) {
    <div class="reply-bar">
      <div class="preview">
        <div class="rep-name">{{ replyTarget.senderName }}</div>
        <div class="rep-text">{{ replyTarget.text }}</div>
      </div>
      <button aria-label="סגירה" class="close-rep" (click)="clearReply()"><mat-icon>close</mat-icon></button>
    </div>
  }
  <div class="input-area">
    <div class="input-wrap">
      <input type="text" [(ngModel)]="newMessage" (keydown)="onKeypress()"
        (keyup.enter)="sendMessage()" placeholder="כתוב הודעה…" aria-label="Type a message"/>
      <button aria-label="הוספת אימוג׳י" class="input-icon"><mat-icon>mood</mat-icon></button>
    </div>
    <button aria-label="שליחה" class="send-btn" [class.disabled]="!newMessage.trim()" (click)="sendMessage()">
      <mat-icon>send</mat-icon>
    </button>
  </div>
}
